export default __webpack_public_path__ + "static/firstimpression-fc87fc9de049ac7cf1a8931ce9208843.webp";